import { render } from "./QuestionInputs.vue?vue&type=template&id=6f02dfe2"
import script from "./QuestionInputs.vue?vue&type=script&lang=js"
export * from "./QuestionInputs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/quiz/components/QuestionInputs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f02dfe2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f02dfe2', __exports__)) {
    api.reload('6f02dfe2', __exports__)
  }
  
  module.hot.accept("./QuestionInputs.vue?vue&type=template&id=6f02dfe2", () => {
    api.rerender('6f02dfe2', render)
  })

}


export default __exports__